import React from 'react';

import makeDeprecatedJadeStyleTemplate from 'util/makeDeprecatedJadeStyleTemplate';

function DigestMenu(): JSX.Element {
  return (
    <ul className="nav navbar-nav form-inline digest-menu">
      <li>
        <input type="text" className="tab-name" defaultValue="Digest" />
        <button type="button" className="button button--tertiaryGray button--mini save">
          Save
        </button>
      </li>
      <li className="enzymes-providers-mount pull-right" />
    </ul>
  );
}

export default makeDeprecatedJadeStyleTemplate(DigestMenu);
